export var MediaType;
(function (MediaType) {
    MediaType[MediaType["NONE"] = 0] = "NONE";
    MediaType[MediaType["VIDEO"] = 1] = "VIDEO";
    MediaType[MediaType["AUDIO"] = 2] = "AUDIO";
    MediaType[MediaType["DISPLAY"] = 3] = "DISPLAY";
})(MediaType || (MediaType = {}));
const MEDIA_TYPE_STRING_MAP = {
    NONE: MediaType.NONE,
    VIDEO: MediaType.VIDEO,
    AUDIO: MediaType.AUDIO,
    DISPLAY: MediaType.DISPLAY
};
export function parseMediaTypeString(value) {
    return value ? MEDIA_TYPE_STRING_MAP[value] : undefined;
}
export var VideoType;
(function (VideoType) {
    VideoType[VideoType["VT_NONE"] = 0] = "VT_NONE";
    VideoType[VideoType["OTT"] = 1] = "OTT";
    VideoType[VideoType["OLV"] = 2] = "OLV";
})(VideoType || (VideoType = {}));
//# sourceMappingURL=media.js.map